export default {
    searching: 'Searching...',
    loading: 'Loading...',
    button_edit: 'Edit',
    button_cancel: 'Cancel',
    button_close: 'Fechar',
    button_delete: 'Delete',
    button_restore: 'Restore',
    button_view: 'View',
    button_view_board: 'View on the board',
    button_add: 'Add',
    button_revoke: 'Revoke',
    button_finish_workload: 'Finish Activity',
    card_not_loaded: 'Sorry, but it was not possible to load the content.',
    resources: {
        workload: 'WorkloadResource'
    },
    total: 'Total',
    yes: 'Yes',
    no: 'No',
    without_category: 'Without Category',
    call: 'Ticket',
    calls: 'Tickets',
    attendance_group: 'Service Group',
    task: 'Task',
    item_checklist: 'Checklist Item',
    tasks: 'Tasks',
    call_archived: 'Ticket is archived',
    task_archived: 'Task is archived',
    most_recent: 'Most Recent',
    older: 'Older',
    verified: 'Verified',
    not_verified: 'Not Verified',
    period: 'Period',
    duration: 'Duration',
    total_time: 'Total Time',
    attendants: 'Attendants',
    running_activity: 'Running Activity',
    main_account_user: 'Main Account User',
    created_at: 'Creation Date',
    author: 'Author',
    user: 'User',
    filters: 'Filters',
    no_filter: 'No Filter',
    download_all: 'Download All',
    unlimited: 'Unlimited',
    answer: 'Answer',
    accept: 'Accept',
    ignore: 'Ignore',
    refuse: 'Refuse',
    no_attendant: 'No Attendant',
    time_left: 'Left {{date}}',
    time_exceeded: 'Exceeded {{date}}',
    task_count_zero: '0 Tasks',
    task_count_one: '1 Task',
    task_count_other: '{{count}} Tasks',
    ticket_count_zero: '0 Tickets',
    ticket_count_one: '1 Ticket',
    ticket_count_other: '{{count}} Tickets',
    responsible_count_zero: '0 Responsible',
    responsible_count_one: '1 Responsible',
    responsible_count_other: '{{count}} Responsible',
    free: 'Free',
    is_plan_default: 'Standard plan',
    days_count_zero: 'No day',
    days_count_one: '1 day',
    days_count_other: '{{count}} days',
    billing_frequency_month_one: 'monthly',
    billing_frequency_month_other: 'every {{count}} months',
    billing_frequency_year: 'yearly',
    here: 'here',
    added_on: 'Added on {{date}}',
    expires_on: 'Expires on {{date}}',
}
